export default __webpack_public_path__ + "static/media/admin.de4d9d3a.svg";